import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/blog21/blog21-1.png";
import image6 from "../../../../assets/images/blog21/blog21-6.png";
import image8 from "../../../../assets/images/blog21/blog21-8.png";
import image2 from "../../../../assets/images/blog21/blog21-2.png";
import image24 from "../../../../assets/images/blog21/blog21-24.png";
import image23 from "../../../../assets/images/blog21/blog21-23.png";
import image22 from "../../../../assets/images/blog21/blog21-22.png";
import image29 from "../../../../assets/images/blog21/blog21-29.png";
import image15 from "../../../../assets/images/blog21/blog21-15.png";
import image18 from "../../../../assets/images/blog21/blog21-18.png";
import image17 from "../../../../assets/images/blog21/blog21-17.png";
import image27 from "../../../../assets/images/blog21/blog21-27.png";
import image33 from "../../../../assets/images/blog21/blog21-33.png";
import image35 from "../../../../assets/images/blog21/blog21-35.png";
import image10 from "../../../../assets/images/blog21/blog21-10.png";
import image40 from "../../../../assets/images/blog21/blog21-40.PNG";

const Blog21 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – June 2, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          Trump, Tariffs & Tokyo Tremors: Strong May, Shaky June
        </p>
        <p>
          May’s rally was historic, S&P +6%, Nasdaq +7.2%, but history warns that June could bring turbulence. With global rate volatility rising, Trump reigniting trade threats, and Japan’s financial
          plumbing groaning, markets now stare down a volatile cocktail of geopolitical friction, central bank inflexion points, and shaky breadth. The calm is thinning. This week’s data barrage and
          ECB rate decision may jolt traders into action.
        </p>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: “The Rally Rests, But It Hasn’t Reversed”</p>
              <p>The market sprinted through May, defying seasonal weakness and topping even the strongest post-election year averages. Now comes the digestion phase.</p>
              <div className="relatedImg">
                <img
                  src={image1}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image1)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Key drivers of the recent rally:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>CTAs turned net long for the first time since March, riding bullish gamma flows</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. equity funds saw continued inflows, while mutual funds are still underweight</p>
                </li>
                <li className="themesPointer">
                  <p>Pros remain underweight tech even as it continues to lead</p>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image8}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image8)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p>Yet SPX is stalling beneath the critical 6,000 level, caught in a tight chop and reacting to every tweet, policy leak, or global scare.</p>
              <div className="relatedImg">
                <img
                  src={image10}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image10)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>The setup remains fragile:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Market internals haven’t broadened, MegaCap tech still dominates</p>
                </li>
                <li className="themesPointer">
                  <p>AI/Chip/Nvidia trades continue to suck in passive and retail capital.</p>
                </li>
                <li className="themesPointer">
                  <p>Positioning is no longer bearish, but neither euphoric, a dangerous middle ground.</p>
                </li>
              </ul>

              <p>Meanwhile, the REAL “TACO” trade (Tech, AI, Chips, Outsourcing) is topping the leaderboard.</p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: “Tariffs, Yields & Yen, The Next Shock”</p>
              <p className="highlightedText">Trump Tariff Gambit Reloaded</p>
              <p>
                Trump proposed a potential 50% tariff on foreign steel and floated the idea of taxing capital inflows, a move that would weaponise the dollar and risk systemic stress in U.S. bond
                demand. While a recent legal ruling limited his Section 232 emergency authority, fallback options (Sections 122, 301, and 338) remain viable.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image40}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image40)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>Institutions fear a policy pivot toward protectionist capital controls:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Foreign investors may reduce Treasury appetite if “entry taxes” are imposed</p>
                </li>
                <li className="themesPointer">
                  <p>The dollar could weaken structurally, but only after a potential funding scare.</p>
                </li>
              </ul>

              <p className="highlightedText">Japan’s Fragile Carry Web</p>
              <p>Japan's bond market is under acute stress as:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Domestic yields rise and foreign appetite wanes</p>
                </li>
                <li className="themesPointer">
                  <p>BOJ faces massive losses from its bond holdings (it owns over 50% of the JGB market)</p>
                </li>
              </ul>

              <p>Repatriation of capital is already visible.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>If the yen strengthens sharply and Japanese equities wobble, it could trigger a cascade of global deleveraging, especially in crowded carry trades.</p>

              <p className="highlightedText">Global Central Banks on Diverging Paths</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>ECB is poised to cut rates this week, but sticky wage inflation and fiscal stress may limit its room</p>
                </li>
                <li className="themesPointer">
                  <p>Fed remains sidelined, soft landing narrative holding, but rising M2 suggests inflation may re-accelerate</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>Markets may be overly optimistic about how much easing is still in the tank.</p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Setups: “Held Up by Flows, Not Fundamentals”</p>
              <p>Despite the surface-level strength, the market internals remain problematic. Price is holding up, but only barely, and largely due to flow mechanics, not fundamental breadth.</p>
              <p className="highlightedText">S&P 500</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Chopping just below the psychologically critical 6,000 level.</p>
                </li>
                <li className="themesPointer">
                  <p>
                    Dealer gamma flows continue to compress volatility intraday, but there's <span className="highlightedText">no confirmation breakout </span>yet.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>CTA models are long but stretched. If SPX fails to hold above 5,850 on weakness, a fast drop to 5,700 is likely.</p>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image10}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image10)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p>Market internals continue to warn:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Fewer than 25% of SPX components are above their 5-day moving average</p>
                </li>
                <li className="themesPointer">
                  <p>Only a handful of MegaCap names are pulling the index higher.</p>
                </li>
                <li className="themesPointer">
                  <p>Equal-weighted indices are underperforming sharply.</p>
                </li>
              </ul>

              <p>Breadth remains thinner than it appears. This is the same internal deterioration seen before major rug pulls in 2018 Q4 and mid-2022.</p>
              <p className="highlightedText">Gold</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Gold continues to absorb quiet hedging flows, especially amid BOJ stress and rising M2.</p>
                </li>
                <li className="themesPointer">
                  <p>Despite significant ETF outflows (–$2.8B YTD), gold is still up 25% YTD, a clear signal of real money accumulation beneath the surface.</p>
                </li>
              </ul>

              <div className="relatedImg">
                <img
                  src={image23}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image23)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p className="highlightedText">Oil</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Rejected lows following bullish surprise in EIA (-2.8m) and API (-4.2m) inventory data.</p>
                </li>
                <li className="themesPointer">
                  <p>Despite macro noise, oil looks stable, indicating the demand side isn’t collapsing yet.</p>
                </li>
              </ul>

              <div className="relatedImg">
                <img
                  src={image22}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image22)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p>Positioning & Flows:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Mutual funds are still underweight equities</p>
                </li>
                <li className="themesPointer">
                  <p>Hedge funds moved back to neutral.</p>
                </li>
                <li className="themesPointer">
                  <p>AI/Chip names continue to attract discretionary and passive flow, but the rest of the market isn’t participating.</p>
                </li>
              </ul>

              <p>This creates a narrow but powerful melt-up condition, until it doesn’t.</p>

              <p>Volatility remains deceptively low, but demand for downside hedges is quietly increasing. Keep a close eye on VIX term structure and VVIX.</p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week in Review: “Flows Up, Fundamentals... Mixed”</p>
              <p>Key macro prints:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Atlanta Fed GDPNow revised up to 3.8% for Q2 (from 2.2%)</p>
                </li>
                <li className="themesPointer">
                  <p>Durable Goods ex-air fell -1.3%, the worst print in six months.</p>
                </li>
                <li className="themesPointer">
                  <p>Disinflation persists in rents, while shelter remains sticky.</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="contentDiv listOfRecap">
            <p>Notable takeaways:</p>
            <ul className="pointersSection">
              <li className="themesPointer">
                <p>U.S. retail earnings skewed defensive</p>
              </li>
              <li className="themesPointer">
                <p>AI-led tech continues to beat, but the reaction is more muted.</p>
              </li>
              <li className="themesPointer">
                <p>Most sector moves were flow-driven, not data-driven</p>
              </li>
            </ul>

            <div className="relatedImg">
              <img
                src={image15}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image15)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>

            <p>The story of last week? Sentiment is strong, but there are cracks forming underneath the hood.</p>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Week Ahead: “Data Flood + ECB Cut = Firestarter Setup”</p>
              <p>This week’s macro calendar is jammed. Every day holds the potential to shift the risk tone.</p>
              <p className="highlightedText">Monday, June 2</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. ISM Manufacturing Index (tariff impacts yet?)</p>
                </li>
                <li className="themesPointer">
                  <p>Global Manufacturing PMIs</p>
                </li>
                <li className="themesPointer">
                  <p>Atlanta Fed GDPNow Update</p>
                </li>
                <li className="themesPointer">
                  <p>FED Powell speaks & BOE Dr Mann</p>
                </li>
              </ul>

              <div className="relatedImg">
                <img
                  src={image40}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image40)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p className="highlightedText">Tuesday, June 3</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. JOLTS Job Openings</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Factory Orders</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone CPI Flash</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. 3M/6M Bill Auctions</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, June 4</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. ADP Private Employment</p>
                </li>
                <li className="themesPointer">
                  <p>ISM Services Index</p>
                </li>
                <li className="themesPointer">
                  <p>Bank of Canada Rate Decision</p>
                </li>
                <li className="themesPointer">
                  <p>Weekly Mortgage Apps</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, June 5</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>ECB Rate Decision (Expected Cut: -25bps)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Initial Jobless Claims</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Trade Balance</p>
                </li>
                <li className="themesPointer">
                  <p>Challenger Job Cuts</p>
                </li>
                <li className="themesPointer">
                  <p>Unit Labour Costs & Productivity</p>
                </li>
              </ul>

              <div className="relatedImg">
                <img
                  src={image35}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image35)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p className="highlightedText">Friday, June 6</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. Non-Farm Payrolls</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Average Hourly Earnings</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Consumer Credit</p>
                </li>
                <li className="themesPointer">
                  <p>Canada Employment Change</p>
                </li>
              </ul>

              <p>This is the highest volatility cluster since early May, expect large moves if any data surprises.</p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: “The Calm Won’t Hold”</p>
              <p>This tape is not euphoric, but it’s fragile. With positioning now neutral, catalysts will dictate direction.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p className="highlightedText">Watch these key signals:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>If SPX can’t clear 6,000, fade the breakout attempts, vol is cheap</p>
                </li>
                <li className="themesPointer">
                  <p>JPY and gold remain your risk-off smoke alarms</p>
                </li>
                <li className="themesPointer">
                  <p>ECB cut will only help if data cooperates, otherwise the downward spiral in EZ inflation may spook markets</p>
                </li>
                <li className="themesPointer">
                  <p>BTC and gold are being accumulated as stealth hedges, not momentum plays</p>
                </li>
              </ul>

              <p>
                Positioning is no longer a tailwind, but not yet a headwind. June is all about whether the “soft landing” remains credible. US equities could outperform a weak $ and Bond outflows.
              </p>

              <p>“Strong Mays often lead to choppy Junes. If breadth doesn’t broaden, the trapdoor is still open.”</p>

              <p>
                Stay sharp. Stay liquid. Watch the yen, gold, and credit, this rally has legs if the global plumbing holds. Indices have called down the earnings, but the multiple is high…that needs
                to see a resolution either way soon, and the pros are mainly underweight.
              </p>
            </div>
          </div>
        </div>

        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1XXlU9YU9yEU4YoeAj6XFMdyHOBTKeH3_0LumujLPcaY/edit?usp=sharing");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog21;
